export const emailStatusText = "Email is not confirmed";
export const inviteNotSent = "Invite not sent";
export const managerSuspendedText = "Suspended";
